import React, { useEffect, useState } from "react";
import Layout from "../../components/global/layout";
import ApiClient from "../../methods/api/apiClient";
import loader from "../../methods/loader";
import environment from "../../environment";
import swal from "sweetalert";
import SelectDropdown from "../../components/common/SelectDropdown";
import PhoneInput from "react-phone-input-2";
import { MdContentCopy } from "react-icons/md";

const CreatePaymentLink = () => {
  const [formPage, setFormPage] = useState(false);
  const [users, setUsers] = useState([]);
  const [usersList, setUsersList] = useState([]);
  const [selectedUser, setSelectedUser] = useState("custom");
  const [showLinkModal, setShowLinkModal] = useState(false);
  const [generatedLink, setGeneratedLink] = useState("");
  const [copied, setCopied] = useState(false);

  const [form, setForm] = useState({
    orderid: "",
    amount: "",
    name: "",
    email: "",
    mobileNo: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [total, setTotal] = useState(0);
  const [filters, setFilter] = useState({
    page: 1,
    count: 10,
    search: "",
    status: "",
  });
  const [filtersone] = useState({
    status: "active",
  });

  const fetchUsers = async (p = {}) => {
    loader(true);
    const params = {
      status: p.status ?? filtersone.status,
      role: environment.user_role_id,
    };
    const query = new URLSearchParams(params).toString();
    await ApiClient.get(`user/listing?${query}`)
      .then((res) => {
        if (res?.success) {
          setUsers([
            { _id: "custom", id: "custom", fullName: "Custom User" },
            ...(res?.data?.data || []),
          ]);
        }
      })
      .catch(console.error);
    loader(false);
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsersdata = async (p = {}) => {
    loader(true);
    const params = {
      page: p.page ?? filters.page,
      count: p.count ?? filters.count,
      search: p.search ?? searchQuery,
      status: p.status ?? filters.status,
      role: environment.user_role_id,
    };
    const query = new URLSearchParams(params).toString();
    await ApiClient.get(`transactions/list?${query}`)
      .then((res) => {
        if (res?.success) {
          setUsersList(res?.data?.data || []);
          setTotal(res.data.total || 0);
        }
      })
      .catch(console.error);
    loader(false);
  };

  useEffect(() => {
    fetchUsersdata();
  }, []);

  useEffect(() => {
    const delay = setTimeout(
      () => fetchUsersdata({ search: searchQuery }),
      500,
    );
    return () => clearTimeout(delay);
  }, [searchQuery]);

  const handleUserSelect = (e) => {
    const value = e?.value;
    setSelectedUser(value);
    setErrors({});
    if (!value || value === "custom") {
      setForm((prev) => ({ ...prev, name: "", email: "", mobileNo: "" }));
      return;
    }
    const user = users.find((u) => (u._id || u.id) === value);
    if (user) {
      setForm((prev) => ({
        ...prev,
        name: `${user.firstName || ""} ${user.lastName || ""}`.trim(),
        email: user.email || "",
        mobileNo: user.mobileNo || "",
      }));
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validate = () => {
    const err = {};
    if (!selectedUser) err.selectedUser = "Please select a user";
    if (!form.orderid.trim()) err.orderid = "Order ID required";
    if (!form.amount || Number(form.amount) <= 0)
      err.amount = "Valid amount required";
    if (!form.name.trim()) err.name = "Name required";
    if (!form.email.trim()) {
      err.email = "Email required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
      err.email = "Invalid email";
    }
    setErrors(err);
    return Object.keys(err).length === 0;
  };

  const resetForm = () => {
    setForm({ orderid: "", amount: "", name: "", email: "", mobileNo: "" });
    setSelectedUser("custom");
    setErrors({});
  };

  const handleSubmit = async () => {
    if (!validate()) return;
    setLoading(true);
    const payload = {
      customer_name: form.name,
      customer_email: form.email,
      customer_mobileNo: form.mobileNo,
      orderId: form.orderid,
      amount: form.amount,
    };
    loader(true);
    ApiClient.post(`user/checkout-link`, payload).then((res) => {
      if (res.success) {
        const link = res?.data?.url;
        setGeneratedLink(link);
        setShowLinkModal(true);
        closeModal();
        fetchUsersdata();
      }
      loader(false);
    });
    setLoading(false);
  };

  const handleCopy = (link) => {
    if (!link) return swal({ text: "No link found!", icon: "error" });
    navigator.clipboard.writeText(link);
    swal({ text: "Copied!", icon: "success" });
  };

  const handleModalCopy = () => {
    navigator.clipboard.writeText(generatedLink);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const closeModal = () => setFormPage(false);
  const openAddModal = () => {
    resetForm();
    setFormPage(true);
  };

  const handlePageChange = (newPage) => {
    const maxPage = Math.ceil(total / filters.count);
    if (newPage < 1 || newPage > maxPage) return;
    setFilter((prev) => ({ ...prev, page: newPage }));
    fetchUsersdata({ page: newPage });
  };

  const totalPages = Math.ceil(total / filters.count);
  const currentPage = Number(filters.page);

  const visiblePages = Array.from(
    { length: totalPages },
    (_, i) => i + 1,
  ).filter(
    (page) =>
      page >= Math.max(1, currentPage - 1) &&
      page <= Math.min(totalPages, currentPage + 1),
  );

  return (
    <Layout>
      {/* ─── Payment Link Generated Modal ─── */}
      {showLinkModal && (
        <div className="absolute min-h-screen inset-0 z-[999] flex items-center justify-center bg-black/40 scrollbar overflow-auto p-5">
          <div className="m-auto bg-white rounded-2xl border border-gray-100 w-full max-w-lg overflow-hidden">
            {/* Header */}
            <div className="p-5 pb-0">
              <div className="flex items-start justify-between mb-5">
                <div className="flex items-center gap-3">
                  <div className="size-11 rounded-xl bg-blue-50 flex items-center justify-center flex-shrink-0">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#115B9D"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
                      <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
                    </svg>
                  </div>
                  <div>
                    <p className="text-[15px] font-medium text-gray-900">
                      Payment link generated
                    </p>
                    <p className="text-[13px] text-gray-600 mt-0.5">
                      Share this link with your customer
                    </p>
                  </div>
                </div>
                <button
                  onClick={() => {
                    setShowLinkModal(false);
                    resetForm();
                  }}
                  className="size-7 rounded-lg border border-gray-200 flex items-center justify-center text-gray-600 hover:bg-gray-50 flex-shrink-0 transition-colors"
                >
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                  >
                    <path d="M18 6 6 18M6 6l12 12" />
                  </svg>
                </button>
              </div>

              {/* Link box */}
              <div className="bg-gray-50 rounded-xl border border-gray-200 px-4 py-3 mb-5">
                <p className="text-[11px] font-medium text-gray-600 uppercase tracking-wide mb-1.5">
                  Payment link
                </p>
                <p className="text-[13px] text-gray-800 break-all leading-relaxed">
                  {generatedLink}
                </p>
              </div>

              {/* Meta info */}
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 mb-6">
                {[
                  { label: "Customer", value: form.name },
                  { label: "Order ID", value: form.orderid },
                  { label: "Amount", value: `$${form.amount}` },
                ].map(({ label, value }) => (
                  <div
                    key={label}
                    className={`bg-gray-50 rounded-xl border border-gray-200 px-3 py-2.5 
        ${label === "Customer" ? "col-span-2 sm:col-span-1" : ""}
      `}
                  >
                    <p className="text-[11px] text-gray-600 mb-1">{label}</p>
                    <p className="text-[13px] font-medium text-gray-900 truncate">
                      {value}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            {/* Footer */}
            <div className="border-t border-gray-100 px-5 py-4 flex gap-2">
              <button
                onClick={handleModalCopy}
                className="flex-1 h-[38px] bg-[#115B9D] hover:opacity-80 text-white text-[13px] font-medium rounded-xl flex items-center justify-center gap-2 transition-all"
              >
                {copied ? (
                  <>
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                    >
                      <path d="M20 6 9 17l-5-5" />
                    </svg>
                    Copied!
                  </>
                ) : (
                  <>
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                    >
                      <rect x="9" y="9" width="13" height="13" rx="2" />
                      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                    </svg>
                    Copy link
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {!formPage ? (
        <div className="max-xl:container xl:max-w-[1280px]  mx-auto">
          {/* ─── Page Header ─── */}
          <div className="flex flex-wrap items-center justify-between gap-2 mb-6">
            <div className="flex flex-col gap-1">
              <h2 className="text-gray-900 text-xl sm:text-2xl font-semibold">
                Create Payment Link
              </h2>
              <p className="text-sm sm:text-md text-gray-600">
                {total} payment link{total !== 1 ? "s" : ""} total
              </p>
            </div>
            <button
              onClick={openAddModal}
              className="w-fit inline-flex items-center gap-2 bg-[#115B9D] hover:opacity-80 text-white text-sm rounded-xl transition-colors font-medium px-5 py-2.5"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M12 5v14M5 12h14" />
              </svg>
              Create Payment Link
            </button>
          </div>

          <div className="w-full border rounded-2xl bg-white p-5 lg:p-8">
            <div className="flex justify-between flex-wrap gap-3 mb-4">
              <div className="relative w-full sm:w-[350px]">
                <svg
                  className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-600"
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="11" cy="11" r="8" />
                  <path d="m21 21-4.3-4.3" />
                </svg>
                <input
                  type="text"
                  placeholder="Search..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full border border-gray-200 rounded-xl pl-9 pr-4 py-2.5 text-sm text-gray-800 outline-none focus:ring-2 focus:ring-[#115B9D]/30 focus:border-[#115B9D] transition-all"
                />
              </div>
            </div>

            {/* ─── Table ─── */}

            {/* Desktop Table */}
            <div className="hidden md:block overflow-hidden border border-gray-200 rounded-xl">
              <table className="w-full table-fixed">
                <colgroup>
                  <col style={{ width: "8%" }} /> {/* Actions */}
                  <col style={{ width: "16%" }} /> {/* Customer Name */}
                  <col style={{ width: "19%" }} /> {/* Customer Email */}
                  <col style={{ width: "13%" }} /> {/* Order Id */}
                  <col style={{ width: "12%" }} /> {/* Amount */}
                  <col style={{ width: "32%" }} /> {/* Link */}
                </colgroup>
                <thead className="bg-gray-50 border-b border-gray-200">
                  <tr>
                    {[
                      "Actions",
                      "Customer Name",
                      "Customer Email",
                      "Order Id",
                      "Amount",
                      "Link",
                    ].map((h) => (
                      <th key={h} className="text-left py-3 px-3">
                        <span className="text-xs text-gray-700 font-medium truncate block">
                          {h}
                        </span>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {usersList?.length === 0 ? (
                    <tr>
                      <td colSpan={6} className="text-center py-16">
                        <div className="flex flex-col items-center gap-3">
                          <div className="size-14 rounded-full bg-gray-100 flex items-center justify-center">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="text-gray-600"
                            >
                              <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                            </svg>
                          </div>
                          <p className="text-sm text-gray-500">No data</p>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    usersList?.map((item, index) => (
                      <tr
                        key={item.id || item._id || index}
                        className="hover:bg-gray-50/60 transition-colors align-middle"
                      >
                        {/* Actions */}
                        <td className="py-2.5 px-3 align-middle">
                          <div className="flex items-center gap-1">
                            <button
                              type="button"
                              onClick={() => handleCopy(item.session_url)}
                              title="Copy"
                              className="size-7 rounded-lg hover:bg-gray-100 flex items-center justify-center text-gray-600 hover:text-[#115B9D] transition-colors shrink-0"
                            >
                              <MdContentCopy />
                            </button>
                          </div>
                        </td>

                        {/* Customer Name */}
                        <td className="py-2.5 px-3 align-middle overflow-hidden">
                          <p className="text-xs text-gray-800 break-words capitalize leading-tight">
                            {item.customer_name || (
                              <span className="text-gray-600">—</span>
                            )}
                          </p>
                        </td>

                        {/* Customer Email — full show, no truncate */}
                        <td className="py-2.5 px-3 align-middle overflow-hidden">
                          <p
                            className="text-xs text-gray-800 break-all leading-tight"
                            title={item.customer_email}
                          >
                            {item.customer_email || (
                              <span className="text-gray-600">—</span>
                            )}
                          </p>
                        </td>

                        {/* Order Id */}
                        <td className="py-2.5 px-3 align-middle overflow-hidden">
                          <p className="text-xs text-gray-800 break-all leading-tight">
                            {item.orderId || (
                              <span className="text-gray-600">—</span>
                            )}
                          </p>
                        </td>

                        {/* Amount */}
                        <td className="py-2.5 px-3 align-middle">
                          <p className="text-xs text-gray-800 whitespace-nowrap">
                            {item.amount || (
                              <span className="text-gray-600">—</span>
                            )}
                          </p>
                        </td>

                        {/* Link */}
                        <td className="py-2.5 px-3 align-middle overflow-hidden">
                          <p
                            className="text-xs text-gray-800 break-all leading-snug truncate cursor-pointer"
                            title={item.session_url}
                          >
                            {item.session_url || (
                              <span className="text-gray-600">—</span>
                            )}
                          </p>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            {/* Mobile Cards */}
            <div className="md:hidden">
              {usersList?.length === 0 ? (
                <div className="border border-gray-200 rounded-xl py-16 flex flex-col items-center gap-3">
                  <div className="size-14 rounded-full bg-gray-100 flex items-center justify-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="text-gray-600"
                    >
                      <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                    </svg>
                  </div>
                  <p className="text-sm text-gray-500">No data</p>
                </div>
              ) : (
                <div className="space-y-3">
                  {usersList?.map((item, index) => (
                    <div
                      key={item.id || item._id || index}
                      className="border border-gray-200 rounded-xl p-4 bg-white"
                    >
                      {/* Top row: Customer Name + Copy action */}
                      <div className="flex items-start justify-between gap-2 mb-2">
                        <p className="text-sm font-medium text-gray-800 capitalize break-words">
                          {item.customer_name || (
                            <span className="text-gray-600 font-normal">—</span>
                          )}
                        </p>
                        <button
                          type="button"
                          onClick={() => handleCopy(item.session_url)}
                          title="Copy"
                          className="size-8 rounded-lg hover:bg-gray-100 flex items-center justify-center text-gray-600 hover:text-[#115B9D] transition-colors shrink-0"
                        >
                          <MdContentCopy />
                        </button>
                      </div>

                      {/* Customer Email */}
                      <div className="flex justify-between items-start py-1.5 border-t border-gray-100">
                        <span className="text-xs text-gray-500 shrink-0">
                          Email
                        </span>
                        <p className="text-sm text-gray-800 text-right break-all ml-3">
                          {item.customer_email || (
                            <span className="text-gray-600">—</span>
                          )}
                        </p>
                      </div>

                      {/* Order Id */}
                      <div className="flex justify-between items-start py-1.5 border-t border-gray-100">
                        <span className="text-xs text-gray-500 shrink-0">
                          Order Id
                        </span>
                        <p className="text-sm text-gray-800 text-right break-all ml-3">
                          {item.orderId || (
                            <span className="text-gray-600">—</span>
                          )}
                        </p>
                      </div>

                      {/* Amount */}
                      <div className="flex justify-between items-center py-1.5 border-t border-gray-100">
                        <span className="text-xs text-gray-500">Amount</span>
                        <p className="text-sm text-gray-800">
                          {item.amount || (
                            <span className="text-gray-600">—</span>
                          )}
                        </p>
                      </div>

                      {/* Link */}
                      <div className="flex flex-col gap-3">
                        <div className="flex justify-between items-start py-1.5 border-t border-gray-100">
                          <span className="text-xs text-gray-500 shrink-0">
                            Link
                          </span>
                        </div>
                          <p className="text-sm text-gray-800 text-right break-all truncate">
                            {item.session_url || (
                              <span className="text-gray-600">—</span>
                            )}
                          </p>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* ─── Pagination ─── */}
            {total > filters.count && (
              <div className="flex flex-wrap gap-y-2 gap-x-5 items-center justify-between mt-4">
                <p className="text-sm text-gray-500">
                  Showing {(filters.page - 1) * filters.count + 1} to{" "}
                  {Math.min(filters.page * filters.count, total)} of {total}
                </p>
                <div className="flex flex-wrap items-center gap-2">
                  <button
                    onClick={() => handlePageChange(filters.page - 1)}
                    disabled={filters.page === 1}
                    className="px-3 py-1.5 text-sm border rounded-lg disabled:opacity-50"
                  >
                    Prev
                  </button>
                  {visiblePages.map((p) => (
                    <button
                      key={p}
                      onClick={() => handlePageChange(p)}
                      className={`px-3 py-1.5 text-sm rounded-lg ${
                        currentPage === p ? "bg-[#115B9D] text-white" : "border"
                      }`}
                    >
                      {p}
                    </button>
                  ))}
                  <button
                    onClick={() => handlePageChange(filters.page + 1)}
                    disabled={filters.page === Math.ceil(total / filters.count)}
                    className="px-3 py-1.5 text-sm border rounded-lg disabled:opacity-50"
                  >
                    Next
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="">
          <div className="">
            <div className="flex items-center gap-3 mb-8">
              <div className="size-10 rounded-xl bg-[#115B9D17] flex items-center justify-center flex-shrink-0">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#115B9D"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                </svg>
              </div>
              <div>
                <h1 className="text-xl font-semibold text-gray-800">
                  Create Payment Link
                </h1>
                <p className="text-sm text-gray-600 mt-0.5">
                  Select user or enter custom details
                </p>
              </div>
            </div>

            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm text-gray-700 mb-1">
                    Select User <span className="text-red-500">*</span>
                  </label>
                  <SelectDropdown
                    name="selectedUser"
                    theme="search"
                    placeholder="Select User"
                    displayValue="fullName"
                    showPlaceHolder={false}
                    options={users}
                    required
                    intialValue={selectedUser}
                    result={handleUserSelect}
                  />
                  {errors.selectedUser && (
                    <p className="text-xs text-red-400 mt-1">
                      {errors.selectedUser}
                    </p>
                  )}
                </div>

                {selectedUser && (
                  <>
                    <Input
                      label="Name"
                      name="name"
                      value={form.name}
                      onChange={handleChange}
                      error={errors.name}
                    />
                    <Input
                      label="Email"
                      name="email"
                      value={form.email}
                      onChange={handleChange}
                      error={errors.email}
                    />
                    <div>
                      <label className="block text-sm text-gray-700 mb-1">
                        Mobile No.
                      </label>
                      <PhoneInput
                        country="us"
                        enableSearch={true}
                        autoFormat={false}
                        placeholder="Enter phone number"
                        value={form?.mobileNo}
                        countryCodeEditable={true}
                        onChange={(e) =>
                          setForm((prev) => ({ ...prev, mobileNo: e || "" }))
                        }
                        buttonClass="!border border-grey !roundehidden !bg-tranparent !rounded-l-large"
                        inputClass="shadow-box border !rounded-large !border-grey !min-h-10 text-sm placeholder:text-gray-500 flex items-center gap-2 overflow-hidden !px-2 !pl-12 !ring-[#115B9D] !outline-[#115B9D]"
                      />
                    </div>
                  </>
                )}

                <Input
                  label="Order ID"
                  name="orderid"
                  value={form.orderid}
                  onChange={handleChange}
                  error={errors.orderid}
                />
                <Input
                  label="Amount"
                  name="amount"
                  type="number"
                  value={form.amount}
                  onChange={handleChange}
                  error={errors.amount}
                />
              </div>
            </div>

            <div className="flex gap-2 flex-wrap items-center justify-end mt-6">
              <button
                className="inline-flex items-center gap-2 text-sm text-gray-600 hover:opacity-80 rounded-xl transition-colors border border-gray-200 bg-white font-medium px-5 py-2.5"
                onClick={closeModal}
              >
                Cancel
              </button>
              <button
                onClick={handleSubmit}
                disabled={loading}
                className="w-fit inline-flex items-center gap-2 bg-[#115B9D] hover:opacity-80 text-white text-sm rounded-xl transition-colors font-medium px-5 py-2.5"
              >
                {loading ? "Generating..." : "Generate Payment Link"}
              </button>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
};

const Input = ({ label, error, ...props }) => (
  <div>
    <label className="text-sm text-gray-700">{label}</label>
    <input
      {...props}
      className={`h-10 w-full border rounded-xl px-3 py-2 text-sm text-gray-800 outline-none focus:ring-2 focus:ring-[#115B9D]/30 focus:border-[#115B9D] transition-all ${
        error ? "border-red-400" : "border-gray-200"
      }`}
    />
    {error && <p className="text-xs text-red-400 mt-1">{error}</p>}
  </div>
);

export default CreatePaymentLink;
